import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import SEOHead from "../../components/common/SEOHead";
import LogoPanda from "../../assets/images/Logo.png";
import { templates } from "../../utilities/objects/template";

const templateMap: Record<string, string> = {
  food: "/Template/Food/value/index.html",
  hotel: "/Template/Hotel/value/index.html",
  edu: "/Template/Edu/value/index.html",
  bds: "/Template/BDS/value/index.html",
};

type DeviceType = "pc" | "tablet" | "phone-landscape" | "phone-portrait";

export default function Preview() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [device, setDevice] = useState<DeviceType>("pc");

  let src = "";
  let name = "";

  if (id) {
    const [category, number] = id.split("-");
    const basePath = templateMap[category];

    if (basePath && number) {
      src = basePath.replace("value", category + number);
    }

    name =
      templates.find((template) => template.id === parseInt(number) && template.category === category)?.name ||
      templates.find((template) => template.id === parseInt(number))?.name ||
      "";
  }

  return (
    <div className="flex min-h-screen w-full flex-col overflow-x-hidden">
      <SEOHead
        title="Preview — TrioCore Solutions"
        description="Xem trước mẫu giao diện website thực tế từ TrioCore Solutions."
        path={`/preview/${id}`}
        noindex={true}
      />

      <div className="fixed inset-x-0 top-0 z-50 border-b border-slate-100 bg-white shadow">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-3 px-3 py-3 md:h-14 md:flex-row md:items-center md:justify-between md:px-6 md:py-0">
          <div className="flex min-w-0 items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="shrink-0 text-[25px] text-gray-600 hover:text-black"
            >
              ←
            </button>
            <img
              src={LogoPanda}
              alt="Logo"
              className="h-8 shrink-0"
              width="32"
              height="32"
              loading="lazy"
            />
            <span className="truncate font-semibold text-gray-800">
              {name?.toUpperCase()}
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:gap-6 md:text-sm">
            <button
              onClick={() => setDevice("pc")}
              className={device === "pc" ? "font-bold text-gray-900" : "text-gray-500"}
            >
              🖥 Máy Tính
            </button>
            <button
              onClick={() => setDevice("tablet")}
              className={device === "tablet" ? "font-bold text-gray-900" : "text-gray-500"}
            >
              📱 Máy Tính Bảng
            </button>
            <button
              onClick={() => setDevice("phone-landscape")}
              className={device === "phone-landscape" ? "font-bold text-gray-900" : "text-gray-500"}
            >
              📱 Điện Thoại Nằm Ngang
            </button>
            <button
              onClick={() => setDevice("phone-portrait")}
              className={device === "phone-portrait" ? "font-bold text-gray-900" : "text-gray-500"}
            >
              📱 Điện Thoại Đứng
            </button>
          </div>

          <button className="mx-auto whitespace-nowrap rounded-[4px] bg-[var(--textBlue57)] px-3 py-1 text-sm font-semibold text-white hover:bg-white hover:text-[var(--textBlue57)] md:mx-0">
            Chọn giao diện này
          </button>
        </div>
      </div>

      <div className="flex-1 bg-gray-100 px-3 pb-4 pt-[132px] md:px-0 md:pt-14">
        <div className="flex h-full items-center justify-center">
          {src ? (
            <div className={`device-frame ${device} overflow-hidden bg-white shadow-lg`}>
              <iframe
                src={src}
                title="Template Preview"
                className="h-full w-full rounded-[12px] border-none custom-scrollbar"
                style={{ overflow: "auto" }}
                onLoad={(event) => {
                  const iframe = event.target as HTMLIFrameElement;

                  try {
                    const style = document.createElement("style");
                    style.textContent = `
                      * {
                        scrollbar-width: thin;
                        scrollbar-color: #cbd5e1 #f1f5f9;
                      }

                      *::-webkit-scrollbar {
                        width: 8px;
                        height: 8px;
                      }

                      *::-webkit-scrollbar-track {
                        background: #f1f5f9;
                        border-radius: 10px;
                      }

                      *::-webkit-scrollbar-thumb {
                        background: linear-gradient(135deg, #64748b, #94a3b8);
                        border-radius: 10px;
                        border: 2px solid #f1f5f9;
                      }

                      *::-webkit-scrollbar-thumb:hover {
                        background: linear-gradient(135deg, #475569, #64748b);
                      }

                      *::-webkit-scrollbar-corner {
                        background: #f1f5f9;
                      }

                      body, html {
                        scrollbar-width: thin;
                        scrollbar-color: #cbd5e1 #f1f5f9;
                      }
                    `;
                    iframe.contentDocument?.head.appendChild(style);
                  } catch (error) {
                    console.log("Cross-origin restriction:", error);
                  }
                }}
              />
            </div>
          ) : (
            <p>Không tìm thấy template</p>
          )}
        </div>
      </div>
    </div>
  );
}
